<template>
  <div>
    <b-modal id="modalEditISGprofileSettings" ref="modalEditISGprofileSettings" :title="$t('ISG profile')" hide-footer @shown="shown" size="xl">
      <div v-if="editItem">
        <b-tabs vertical pills card>
          <b-tab  :title="$t('Main')" active>
            <b-form-group label-align="right" v-if="editItem.id != 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="editItem.id" disabled/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                  {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Login type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select @change="changeLoginType" v-model="editItem.login_type" :options="loginType"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Password type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :disabled="editItem.login_type == 5" v-model="editItem.password_type" :options="passwordType"/>
            </b-form-group>
            <b-form-group label-align="right" v-if="editItem.password_type === 2" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.static_password"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Authorisation timeout')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.session_time" aria-describedby="inputFeedbackTimeout" :state="editItem.session_time > 0"/>
              <b-form-invalid-feedback id="inputFeedbackTimeout">
                  {{ $t('Enter number') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Unlocked account code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.unblocked_account_code" :options="unlockedCode"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Blocked account code')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.blocked_account_code" :options="blockedCode"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Assign address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox switch size="lg" v-model="editItem.lease_address"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Switch types')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="editItem.switch_type_id" :options="switchTypes"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Set RADIUS parameters')" @click="SetRadAttrGeneral">
            <md-button class="md-raised" @click="swohAddRadiusAttr" >{{ $t('Add') }}</md-button>
            <b-table :key="rerenderRadiusAttrs" small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditRadiusAttrISGButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg" />
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Socially significant resources')" @click="SetRadAttrSIR">
            <b-row>
              <b-col style="margin:5px">
                <b-checkbox switch size="md" v-model="editItem.is_enabled_sir">{{ $t('Active') }}</b-checkbox>
              </b-col>
            </b-row>
            <b-tabs pills card>
              <b-tab :title="$t('RADIUS parameters')">
                <b-row>
                <b-col style="margin-top:-10px">
                  <md-button class="md-raised" @click="swohAddRadiusAttrSIR" >{{ $t('Add') }}</md-button>
                </b-col>
                </b-row>

              <b-table :key="rerenderSIRAtrs" small striped hover :items="radiusAttrSIRItems" :fields="radiusAttrSIRFields">
                <template v-slot:cell(actions)="row">
                  <i @click.stop="ClickOnEditRadiusAttrSIRButton(row)" class="primary fa fa-edit fa-lg"/>
                  <i @click.stop="deleteRadiusAttrSIR(row)" class="danger fa fa-trash-alt fa-lg" />
                </template>
              </b-table>
              </b-tab>
              <b-tab :title="$t('CoA RADIUS parameters')">
                <b-row>
                  <b-col style="margin-bottom:1rem">
                    <b-checkbox switch size="md" @change="ChangeEnableSirCoa" value="1" unchecked-value="0" v-model="registrySettings[0].raw_values[0].value">{{ $t('Active') }}</b-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col style="margin-top:-10px">
                    <md-button class="md-raised" @click="swohAddCoARadiusAttrSIR" >{{ $t('Add') }}</md-button>
                  </b-col>
                </b-row>
                <b-table :key="rerenderSIRCoAAttrs" small striped hover :items="radiusAttrsCoASIRItems" :fields="CoAradiusAttrSIRFields">
                <template v-slot:cell(actions)="row">
                  <i @click.stop="ClickOnEditCoARadiusAttrSIRButton(row)" class="primary fa fa-edit fa-lg"/>
                  <i @click.stop="deleteRadiusAttrCoASIR(row)" class="danger fa fa-trash-alt fa-lg" />
                </template>
              </b-table>
              </b-tab>
            </b-tabs>

          </b-tab>
          <b-tab title="CoA" @click="SetRadAttrCoA">
            <b-row>
              <b-col style="margin:5px">
                <b-checkbox switch size="md" v-model="editItem.send_coa">{{ $t('Active') }}</b-checkbox>
                <md-button class="md-raised" @click="swohAddRadiusAttrCoA" :disabled="!editItem.send_coa">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table :key="rerenderCoAAttrs" small striped hover :items="radiusAttrCoAItems" :fields="radiusAttrCoAFields">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditRadiusAttrCoAButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteRadiusAttrCoA(row)" class="danger fa fa-trash-alt fa-lg" />
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditISGprofileSettings')" size="xl"/>
      </div>
    </b-modal>

    <b-modal hide-footer @hidden="radiusAttrModalFormHide" :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @hideAddRadiusAttr="hideAddRadiusAttr"
      @editedCoa="editedCoa"
      @editedSIR="editedSIR"
      @editedCoASIRonRun="editedCoASIRonRun"
      @editedCoASIRonClose="editedCoASIRonClose"

      @editedISGAttr="editedISGAttr"
      @restoreISGAttr="restoreISGAttr"
      :isISGprofile="isISGprofile"

      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"
      :radiusAttrItemsChanges="radiusAttrItemsChanges"

      :isRadiusAttrCoa="isRadiusAttrCoa"
      :radiusAttrCoAItems="radiusAttrCoAItems"
      :radiusAttrCoAItemsChanges="radiusAttrCoAItemsChanges"

      :isRadiusAttrSIR="isRadiusAttrSIR"
      :isCoARadiusAttrSIR="isCoARadiusAttrSIR"
      :radiusAttrSIRItems="radiusAttrSIRItems"
      :radiusAttrsCoASIRItems="radiusAttrsCoASIRItems"
      :radiusAttrSIRItemsChanges="radiusAttrSIRItemsChanges"
      :radiusAttrsCoASIRItemsChanges="radiusAttrsCoASIRItemsChanges"/>
    </b-modal>
  </div>
</template>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'

export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    editItem: null
  },
  data () {
    return {
      isEnableSirCoa: '0',
      radiusAttrsCoASIRItemsChanges: {delete: [], add: []},
      radiusAttrsCoASIRItems: [],
      typeCoASIRonStart: 10,
      typeCoASIRonEnd: 11,
      isRadiusAccounts: false,
      radiusAttrItemsChanges: {delete: [], add: []},
      radiusAttrCoAItemsChanges: {delete: [], add: []},
      radiusAttrSIRItemsChanges: {delete: [], add: []},
      descIsEnabledSIR: this.$i18n.t('enables SSR'),
      isISGprofile: true,
      radiusAttr: {
        'set_object_id': 0,
        'set_type': 7,
        'attrs': []
      },
      radiusAttrCoA: {
        'set_object_id': 0,
        'set_type': 8,
        'attrs': []
      },
      radiusAttrSIR: {
        'set_object_id': 0,
        'set_type': 9,
        'attrs': []
      },
      radiusAttrSIRonRun: {
        'set_object_id': 0,
        'set_type': 10,
        'attrs': []
      },
      radiusAttrSIRonClose: {
        'set_object_id': 0,
        'set_type': 11,
        'attrs': []
      },
      isRadiusAttrCoa: false,
      radiusAttrCoAItems: [],
      radiusAttrCoAFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service', label: this.$i18n.t('Service'), sortable: true},
        {key: 'event', label: this.$i18n.t('Event'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service', label: this.$i18n.t('Service'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isRadiusAttrSIR: false,
      radiusAttrSIRItems: [],
      radiusAttrCoASIRItems: [],
      radiusAttrSIRFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service', label: this.$i18n.t('Service'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      CoAradiusAttrSIRFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'object_type',
          label: this.$i18n.t('On CoA action'),
          sortable: true,
          formatter: (val, key, item) => {
            switch (val) {
              case 10 :
                return this.$t('On start')
              case 11:
                return this.$t('On end')
              default:
                return this.$t('unknown')
            }
          }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      passwordType: [
        {value: 1, text: this.$i18n.t('Password in IP group')},
        {value: 2, text: this.$i18n.t('Static')},
        {value: 4, text: this.$i18n.t('Same as login')}
      ],
      loginType: [
        {value: 1, text: 'IP'},
        {value: 2, text: 'MAC'},
        {value: 3, text: this.$i18n.t('Login in IP group')},
        {value: 4, text: 'Custom login'},
        {value: 5, text: 'Option 82'}
      ],
      unlockedCode: [
        {value: 2, text: 'Access-Accept'},
        {value: 3, text: 'Access-Reject'}
      ],
      blockedCode: [
        {value: 2, text: 'Access-Accept'},
        {value: 3, text: 'Access-Reject'}
      ],
      editedISGattrs: {set_type: 7, set_object_id: 0, attrs: []},
      editedCoAattrs: {set_type: 8, set_object_id: 0, attrs: []},
      editedSIRattrs: {set_type: 9, set_object_id: 0, attrs: []},
      editedCoASIRonRunAttrs: {set_type: 10, set_object_id: 0, attrs: []},
      editedCoASIRonCloseAttrs: {set_type: 11, set_object_id: 0, attrs: []},
      isCoARadiusAttrSIR: false,
      rerenderRadiusAttrs: 0,
      rerenderSIRAtrs: 0,
      rerenderSIRCoAAttrs: 0,
      rerenderCoAAttrs: 0
    }
  },
  methods: {
    ChangeEnableSirCoa (val) {
      let tmp = JSON.parse(JSON.stringify(this.registrySettings[0]))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(val)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 19, object_id: 0})
    },
    restoreISGAttr (attr) {
      if (this.isRadiusAttrCoa) {
        this.radiusAttrCoAItems = this.radiusAttrCoAItems.map(
          el => el.database_id === attr.database_id ? attr : el)
      }
      if (this.isEditRadiusAttr) {
        this.radiusAttrItems = this.radiusAttrItems.map(
          el => el.database_id === attr.database_id ? attr : el)
      }
      if (this.isRadiusAttrSIR) {
        this.radiusAttrSIRItems = this.radiusAttrSIRItems.map(
          el => el.database_id === attr.database_id ? attr : el)
      }
    },
    changeLoginType (val) {
      if (val === 5) {
        this.editItem.password_type = 2
      }
    },
    editedCoa (item) {
      this.editedCoAattrs.attrs = this.editedCoAattrs.attrs.filter(el => {
        return el.database_id !== item.database_id
      })
      this.editedCoAattrs.set_object_id = this.editItem.id
      this.editedCoAattrs.attrs.push(item)
    },
    editedSIR (item) {
      this.editedSIRattrs.attrs = this.editedSIRattrs.attrs.filter(el => {
        return el.database_id !== item.database_id
      })
      this.editedSIRattrs.set_object_id = this.editItem.id
      this.editedSIRattrs.attrs.push(item)
    },
    editedCoASIRonRun (item) {
      this.editedCoASIRonRunAttrs.attrs = this.editedCoASIRonRunAttrs.attrs.filter(el => {
        return el.database_id !== item.database_id
      })
      this.editedCoASIRonRunAttrs.set_object_id = this.editItem.id
      this.editedCoASIRonRunAttrs.attrs.push(item)

      this.radiusAttrsCoASIRItems.forEach(element => {
        if (element.database_id === item.database_id) {
          element = JSON.parse(JSON.stringify(item))
          this.rerenderSIRCoAAttrs += 1
        }
      })
    },
    editedCoASIRonClose (item) {
      this.editedCoASIRonCloseAttrs.attrs = this.editedCoASIRonCloseAttrs.attrs.filter(el => {
        return el.database_id !== item.database_id
      })
      this.editedCoASIRonCloseAttrs.set_object_id = this.editItem.id
      this.editedCoASIRonCloseAttrs.attrs.push(item)
      this.radiusAttrsCoASIRItems.forEach(element => {
        if (element.database_id === item.database_id) {
          element = JSON.parse(JSON.stringify(item))
          this.rerenderSIRCoAAttrs += 1
        }
      })
    },
    editedISGAttr (item) {
      this.editedISGattrs.attrs = this.editedISGattrs.attrs.filter(el => {
        return el.database_id !== item.database_id
      })
      this.editedISGattrs.set_object_id = this.editItem.id
      this.editedISGattrs.attrs.push(item)
    },
    async SetRadAttrGeneral () {
      await this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_ISG_PROFILE', this.editItem.id).then(resp => {
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_ISG_PROFILE']))
      })
      this.editedISGattrs.attrs = []
      this.radiusAttrItemsChanges = {delete: [], add: []}
      this.shown()
    },
    async SetRadAttrCoA () {
      await this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_ISG_COA', this.editItem.id).then(resp => {
        this.radiusAttrCoAItems = this.$store.getters['Tariffing/RADIUS_ATTR_ISG_COA']
      })
      this.editedCoAattrs.attrs = []
      this.radiusAttrCoAItemsChanges = {delete: [], add: []}
      this.shown()
    },
    async SetRadAttrSIR () {
      await this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_ISG_SIR', this.editItem.id).then(resp => {
        this.radiusAttrSIRItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_ISG_SIR']))
      })
      await this.$store.dispatch('Tariffing/GET_COA_RADIUS_ATTR_ISG_SIR', {object_id: this.editItem.id, object_type: 10}).then(resp => {
        let onRunAttrs = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_ISG_SIR']))
        onRunAttrs.forEach(element => {
          element.object_type = 10
        })
        this.radiusAttrsCoASIRItems = onRunAttrs
      })
      await this.$store.dispatch('Tariffing/GET_COA_RADIUS_ATTR_ISG_SIR', {object_id: this.editItem.id, object_type: 11}).then(resp => {
        let onCloseAttrs = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_ISG_SIR']))

        onCloseAttrs.forEach(element => {
          element.object_type = 11
        })
        this.radiusAttrsCoASIRItems = this.radiusAttrsCoASIRItems.concat(onCloseAttrs)
      })
      this.radiusAttrSIRItemsChanges = {delete: [], add: []}
      this.radiusAttrsCoASIRItemsChanges = {delete: [], add: []}
      this.editedSIRattrs.attrs = []
      this.editedCoASIRonRunAttrs.attrs = []
      this.editedCoASIRonCloseAttrs.attrs = []
      this.shown()
    },
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.editItem.session_time) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Authorisation timeout fields is invalid'), 'Error')
        return
      }

      this.editItem.session_time = Number(this.editItem.session_time)
      if (this.editItem.password_type === 1) {
        this.editItem.static_password = ''
      }
      for (let el of this.radiusAttrItems) {
        if (!el.properties[0]) {
          el.properties.push({property_type: 1, property_value: ''})
          el.properties.push({property_type: 2, property_value: ''})
        }
        el.properties[0].property_value = String(el.properties[0].property_value)
      }
      for (let el of this.radiusAttrCoAItems) {
        if (!el.properties[0]) {
          el.properties.push({property_type: 1, property_value: ''})
          el.properties.push({property_type: 2, property_value: ''})
        }
        el.properties[0].property_value = String(el.properties[0].property_value)
      }
      this.editItem.isg_profile_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_ISG_PROFILE', this.editItem)
        : this.$store.dispatch('Settings/CREATE_ISG_PROFILE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          if (this.editItem.id) {
            this.radiusAttr.set_object_id = this.editItem.id
            this.radiusAttrCoA.set_object_id = this.editItem.id
            this.radiusAttrSIR.set_object_id = this.editItem.id
            this.radiusAttrSIRonRun.set_object_id = this.editItem.id
            this.radiusAttrSIRonClose.set_object_id = this.editItem.id
          } else {
            this.radiusAttr.set_object_id = response.data.isg_profile_id
            this.radiusAttrCoA.set_object_id = response.data.isg_profile_id
            this.radiusAttrSIR.set_object_id = response.data.isg_profile_id
            this.radiusAttrSIRonRun.set_object_id = response.data.isg_profile_id
            this.radiusAttrSIRonClose.set_object_id = response.data.isg_profile_id
          }
          this.radiusAttr.attrs = this.radiusAttrItems
          this.radiusAttrSIR.attrs = this.radiusAttrSIRItems

          this.radiusAttrAPI()

          if (this.editItem.send_coa) {
            this.radiusAttrCoA.attrs = this.radiusAttrCoAItems
          } else {
            this.radiusAttrCoA.attrs = []
          }
          this.radiusAttrCoAAPI()
          this.radiusAttrSIRAPI()
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ISG_PROFILE')
          this.$refs.modalEditISGprofileSettings.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    radiusAttrAPI () {
      if (this.radiusAttrItemsChanges.delete.length > 0) {
        for (let el of this.radiusAttrItemsChanges.delete) {
          this.$store.dispatch('Tariffing/DELETE_RADIUS_ATTR', {object_id: this.radiusAttr.set_object_id, object_type: this.radiusAttr.set_type, radius_attr_id: el.database_id})
        }
        this.radiusAttrItemsChanges.delete = []
      }
      if (this.radiusAttrItemsChanges.add.length > 0) {
        this.radiusAttr.is_single_attr = true
        this.radiusAttr.attrs = this.radiusAttrItemsChanges.add
        this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttr)
        this.radiusAttrItemsChanges.add = []
      }
      if (this.editedISGattrs.attrs && this.editedISGattrs.attrs.length > 0) {
        this.$store.dispatch('Tariffing/REWRITE_RADIUS_ATTR', JSON.parse(JSON.stringify(this.editedISGattrs)))
        this.editedISGattrs.attrs = []
      }
    },
    radiusAttrCoAAPI () {
      if (this.radiusAttrCoAItemsChanges.delete.length > 0) {
        for (let el of this.radiusAttrCoAItemsChanges.delete) {
          this.$store.dispatch('Tariffing/DELETE_RADIUS_ATTR', {object_id: this.radiusAttrCoA.set_object_id, object_type: this.radiusAttrCoA.set_type, radius_attr_id: el.database_id})
        }
        this.radiusAttrCoAItemsChanges.delete = []
      }
      if (this.radiusAttrsCoASIRItemsChanges.delete.length > 0) {
        for (let el of this.radiusAttrsCoASIRItemsChanges.delete) {
          this.$store.dispatch('Tariffing/DELETE_RADIUS_ATTR', {object_id: this.radiusAttrCoA.set_object_id, object_type: el.object_type, radius_attr_id: el.database_id})
        }
        this.radiusAttrsCoASIRItemsChanges.delete = []
      }
      if (this.radiusAttrCoAItemsChanges.add.length > 0) {
        this.radiusAttrCoA.is_single_attr = true
        this.radiusAttrCoA.attrs = this.radiusAttrCoAItemsChanges.add
        this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttrCoA)
        this.radiusAttrCoAItemsChanges.add = []
      }
      if (this.editedCoAattrs.attrs && this.editedCoAattrs.attrs.length > 0) {
        this.$store.dispatch('Tariffing/REWRITE_RADIUS_ATTR', JSON.parse(JSON.stringify(this.editedCoAattrs)))
        this.editedCoAattrs.attrs = []
      }
    },
    radiusAttrSIRAPI () {
      if (this.radiusAttrSIRItemsChanges.delete.length > 0) {
        for (let el of this.radiusAttrSIRItemsChanges.delete) {
          this.$store.dispatch('Tariffing/DELETE_RADIUS_ATTR', {object_id: this.radiusAttrSIR.set_object_id, object_type: this.radiusAttrSIR.set_type, radius_attr_id: el.database_id})
        }
        this.radiusAttrSIRItemsChanges.delete = []
      }
      if (this.radiusAttrSIRItemsChanges.add.length > 0) {
        this.radiusAttrSIR.is_single_attr = true
        this.radiusAttrSIR.attrs = this.radiusAttrSIRItemsChanges.add
        this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttrSIR)
        this.radiusAttrSIRItemsChanges.add = []
      }
      if (this.editedSIRattrs.attrs && this.editedSIRattrs.attrs.length > 0) {
        this.$store.dispatch('Tariffing/REWRITE_RADIUS_ATTR', JSON.parse(JSON.stringify(this.editedSIRattrs)))
        this.editedSIRattrs.attrs = []
      }
      if (this.editedCoASIRonRunAttrs.attrs && this.editedCoASIRonRunAttrs.attrs.length > 0) {
        this.$store.dispatch('Tariffing/REWRITE_RADIUS_ATTR', JSON.parse(JSON.stringify(this.editedCoASIRonRunAttrs)))
        this.editedCoASIRonRunAttrs.attrs = []
      }
      if (this.editedCoASIRonCloseAttrs.attrs && this.editedCoASIRonCloseAttrs.attrs.length > 0) {
        this.$store.dispatch('Tariffing/REWRITE_RADIUS_ATTR', JSON.parse(JSON.stringify(this.editedCoASIRonCloseAttrs)))
        this.editedCoASIRonCloseAttrs.attrs = []
      }

      if (this.radiusAttrsCoASIRItemsChanges.add.length > 0) {
        let onRunCoAsirAttrs = this.radiusAttrsCoASIRItemsChanges.add.filter(el => el.object_type === 10)
        let onCloseCoAsirAttrs = this.radiusAttrsCoASIRItemsChanges.add.filter(el => el.object_type === 11)
        if (onRunCoAsirAttrs.length) {
          this.radiusAttrSIRonRun.is_single_attr = true
          this.radiusAttrSIRonRun.attrs = onRunCoAsirAttrs
          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttrSIRonRun)
          this.radiusAttrsCoASIRItemsChanges.add = this.radiusAttrsCoASIRItemsChanges.add.filter(el => el.object_type === 11)
        }
        if (onCloseCoAsirAttrs.length) {
          this.radiusAttrSIRonClose.is_single_attr = true
          this.radiusAttrSIRonClose.attrs = onCloseCoAsirAttrs
          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', this.radiusAttrSIRonClose)
          this.radiusAttrsCoASIRItemsChanges.add = this.radiusAttrsCoASIRItemsChanges.add.filter(el => el.object_type === 10)
        }
      }
    },

    prepareRadiusAttrsHelper (preparedItems) {
      for (let i in preparedItems) {
        preparedItems[i].value = preparedItems[i].attr_value

        if (!preparedItems[i].properties[0]) {
          preparedItems[i].properties.push({property_type: 1, property_value: ''})
          preparedItems[i].properties.push({property_type: 2, property_value: ''})
        }

        if (preparedItems[i].properties[0].property_value === '') {
          preparedItems[i].service = this.$i18n.t('All services')
        } else {
          for (let el of this.$store.getters['Tariffing/SERVICES']) {
            if (el.service_id === Number(preparedItems[i].properties[0].property_value)) {
              preparedItems[i].service = el.service_name + '(' + el.service_id + ')'
            }
          }
        }
        if (preparedItems[i].tag && (preparedItems[i].vendor === 0)) {
          preparedItems[i].value = ':' + preparedItems[i].tag + ':' + preparedItems[i].attr_value
        }
        switch (preparedItems[i].attr_type) {
          case 1:
            preparedItems[i].attrType = this.$i18n.t('Number')
            break
          case 2:
            preparedItems[i].attrType = this.$i18n.t('String')
            break
          case 3:
            preparedItems[i].attrType = 'IP'
            break
          case 4:
            preparedItems[i].attrType = this.$i18n.t('Binary')
            break
        }
      }
    },
    rerenderTables () {
      this.rerenderRadiusAttrs += 1
      this.rerenderSIRAtrs += 1
      this.rerenderSIRCoAAttrs += 1
      this.rerenderCoAAttrs += 1
    },
    shown () {
      if (this.editItem.id) {
        this.prepareRadiusAttrsHelper(this.radiusAttrItems)
        this.prepareRadiusAttrsHelper(this.radiusAttrSIRItems)
        this.prepareRadiusAttrsHelper(this.radiusAttrsCoASIRItems)

        for (let i in this.radiusAttrCoAItems) {
          this.radiusAttrCoAItems[i].value = this.radiusAttrCoAItems[i].attr_value
          if (!this.radiusAttrCoAItems[i].properties[0]) {
            this.radiusAttrCoAItems[i].properties.push({property_type: 1, property_value: ''})
            this.radiusAttrCoAItems[i].properties.push({property_type: 2, property_value: ''})
          }
          if (this.radiusAttrCoAItems[i].properties[0].property_value === '') {
            this.radiusAttrCoAItems[i].service = this.$i18n.t('All services')
          } else {
            for (let el of this.$store.getters['Tariffing/SERVICES']) {
              if (el.service_id === Number(this.radiusAttrCoAItems[i].properties[0].property_value)) {
                this.radiusAttrCoAItems[i].service = el.service_name + '(' + el.service_id + ')'
              }
            }
          }
          switch (this.radiusAttrCoAItems[i].properties[1].property_value) {
            case '1':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('Blocked')
              break
            case '0':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('Unbloked')
              break
            case '2':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('Delete service link')
              break
            case '3':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('Switch tariff')
              break
            case '':
              this.radiusAttrCoAItems[i].event = this.$i18n.t('All states')
              break
          }
          if (this.radiusAttrCoAItems[i].tag && (this.radiusAttrCoAItems[i].vendor === 0)) {
            this.radiusAttrCoAItems[i].value = ':' + this.radiusAttrCoAItems[i].tag + ':' + this.radiusAttrCoAItems[i].attr_value
          }
          switch (this.radiusAttrCoAItems[i].attr_type) {
            case 1:
              this.radiusAttrCoAItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrCoAItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrCoAItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrCoAItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
      }
      this.rerenderTables()
    },

    swohAddRadiusAttrCoA () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.isRadiusAttrCoa = true
      this.isRadiusAttrSIR = false
      this.$refs.modalRadiusAttr.show()
    },
    swohAddRadiusAttrSIR () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.isRadiusAttrCoa = false
      this.isRadiusAttrSIR = true
      this.$refs.modalRadiusAttr.show()
    },
    swohAddCoARadiusAttrSIR () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.isRadiusAttrCoa = false
      this.isRadiusAttrSIR = false
      this.isCoARadiusAttrSIR = true
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrCoAButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.isRadiusAttrCoa = true
      this.isRadiusAttrSIR = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrSIRButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.isRadiusAttrCoa = false
      this.isRadiusAttrSIR = true
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditCoARadiusAttrSIRButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.isRadiusAttrCoa = false
      this.isRadiusAttrSIR = false
      this.isCoARadiusAttrSIR = true
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrISGButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.isRadiusAttrCoa = false
      this.isRadiusAttrSIR = false
      this.isCoARadiusAttrSIR = true
      this.$refs.modalRadiusAttr.show()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
      this.radiusAttrItemsChanges.delete.push(row.item)
    },
    deleteRadiusAttrCoA (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrCoAItems = this.radiusAttrCoAItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
      this.radiusAttrCoAItemsChanges.delete.push(row.item)
    },
    deleteRadiusAttrCoASIR (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrsCoASIRItems = this.radiusAttrsCoASIRItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
      this.radiusAttrsCoASIRItemsChanges.delete.push(row.item)
    },
    deleteRadiusAttrSIR (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrSIRItems = this.radiusAttrSIRItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
      this.radiusAttrSIRItemsChanges.delete.push(row.item)
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.isRadiusAttrCoa = false
      this.isRadiusAttrSIR = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.isRadiusAttrCoa = false
      this.isRadiusAttrSIR = false
      this.$refs.modalRadiusAttr.show()
    },
    radiusAttrModalFormHide (event) {
      this.isCoARadiusAttrSIR = false
      this.isISGprofile = true
    },
    hideAddRadiusAttr () {
      // For pushing reactivity
      this.isISGprofile = true
      this.isRadiusAccounts = false
      this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      this.radiusAttrCoAItems = JSON.parse(JSON.stringify(this.radiusAttrCoAItems))
      this.radiusAttrSIRItems = JSON.parse(JSON.stringify(this.radiusAttrSIRItems))
      this.$refs.modalRadiusAttr.hide()
    }
  },

  computed: {
    registrySettings () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'sir_is_coa_enabled'
      })
    },
    switchTypes () {
      let res = this.$store.getters['Inventory/SWITCH_TYPES']
      let switchTypes = []
      for (let el of res) {
        let newSwitch = {
          value: 0,
          text: ''
        }
        newSwitch.value = el.id
        newSwitch.text = el.name
        switchTypes.push(newSwitch)
      }
      return switchTypes
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 19, object_id: 0})
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/ISGprofile/editModal.vue